import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Options overview",
  "description": "Flags, configurations, and System Environment Variables for Turborepo"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "There are three ways to manage the behavior of a turbo invocation:"
  }, {
    "heading": "",
    "content": "Configuration in turbo.json"
  }, {
    "heading": "",
    "content": "System Environment Variables"
  }, {
    "heading": "",
    "content": "Flags passed to the CLI invocation"
  }, {
    "heading": "",
    "content": "The three strategies listed above are in order of precedence. Where a flag value is provided, for the same System Environment Variable or turbo.json configuration, the value for the flag will be used. Because of this, we recommend using:"
  }, {
    "heading": "",
    "content": "turbo.json configuration for defaults"
  }, {
    "heading": "",
    "content": "System Environment Variables for per-environment overrides"
  }, {
    "heading": "",
    "content": "Flags for per-invocation overrides"
  }, {
    "heading": "caching",
    "content": "Behavior"
  }, {
    "heading": "caching",
    "content": "Flags"
  }, {
    "heading": "caching",
    "content": "Environment Variables"
  }, {
    "heading": "caching",
    "content": "turbo.json"
  }, {
    "heading": "caching",
    "content": "Force tasks to run"
  }, {
    "heading": "caching",
    "content": "--force"
  }, {
    "heading": "caching",
    "content": "TURBO_FORCE"
  }, {
    "heading": "caching",
    "content": "cache"
  }, {
    "heading": "caching",
    "content": "Remote Cache timeout"
  }, {
    "heading": "caching",
    "content": "--remote-cache-timeout"
  }, {
    "heading": "caching",
    "content": "TURBO_REMOTE_CACHE_TIMEOUT"
  }, {
    "heading": "caching",
    "content": "remoteCache.timeout"
  }, {
    "heading": "caching",
    "content": "Remote Cache upload timeout"
  }, {
    "heading": "caching",
    "content": "-"
  }, {
    "heading": "caching",
    "content": "TURBO_REMOTE_CACHE_UPLOAD_TIMEOUT"
  }, {
    "heading": "caching",
    "content": "remoteCache.uploadTimeout"
  }, {
    "heading": "caching",
    "content": "Cache signature key"
  }, {
    "heading": "caching",
    "content": "-"
  }, {
    "heading": "caching",
    "content": "TURBO_REMOTE_CACHE_SIGNATURE_KEY"
  }, {
    "heading": "caching",
    "content": "signature"
  }, {
    "heading": "caching",
    "content": "Preflight request"
  }, {
    "heading": "caching",
    "content": "--preflight"
  }, {
    "heading": "caching",
    "content": "TURBO_PREFLIGHT"
  }, {
    "heading": "caching",
    "content": "remoteCache.preflight"
  }, {
    "heading": "caching",
    "content": "Remote Cache base URL"
  }, {
    "heading": "caching",
    "content": "-"
  }, {
    "heading": "caching",
    "content": "TURBO_API"
  }, {
    "heading": "caching",
    "content": "remoteCache.apiUrl"
  }, {
    "heading": "caching",
    "content": "Cache sources"
  }, {
    "heading": "caching",
    "content": "--cache"
  }, {
    "heading": "caching",
    "content": "TURBO_CACHE"
  }, {
    "heading": "caching",
    "content": "-"
  }, {
    "heading": "caching",
    "content": "Local cache directory"
  }, {
    "heading": "caching",
    "content": "--cache-dir"
  }, {
    "heading": "caching",
    "content": "TURBO_CACHE_DIR"
  }, {
    "heading": "caching",
    "content": "cacheDir"
  }, {
    "heading": "messages",
    "content": "Behavior"
  }, {
    "heading": "messages",
    "content": "Flags"
  }, {
    "heading": "messages",
    "content": "Environment Variables"
  }, {
    "heading": "messages",
    "content": "turbo.json"
  }, {
    "heading": "messages",
    "content": "Disable version print"
  }, {
    "heading": "messages",
    "content": "-"
  }, {
    "heading": "messages",
    "content": "TURBO_PRINT_VERSION_DISABLED"
  }, {
    "heading": "messages",
    "content": "-"
  }, {
    "heading": "messages",
    "content": "Disable telemetry message"
  }, {
    "heading": "messages",
    "content": "-"
  }, {
    "heading": "messages",
    "content": "TURBO_TELEMETRY_MESSAGE_DISABLED"
  }, {
    "heading": "messages",
    "content": "-"
  }, {
    "heading": "messages",
    "content": "Disable global turbo warning"
  }, {
    "heading": "messages",
    "content": "-"
  }, {
    "heading": "messages",
    "content": "TURBO_GLOBAL_WARNING_DISABLED"
  }, {
    "heading": "messages",
    "content": "-"
  }, {
    "heading": "messages",
    "content": "No update notifier"
  }, {
    "heading": "messages",
    "content": "-"
  }, {
    "heading": "messages",
    "content": "TURBO_NO_UPDATE_NOTIFIER"
  }, {
    "heading": "messages",
    "content": "-"
  }, {
    "heading": "task-running-and-logs",
    "content": "Behavior"
  }, {
    "heading": "task-running-and-logs",
    "content": "Flags"
  }, {
    "heading": "task-running-and-logs",
    "content": "Environment Variables"
  }, {
    "heading": "task-running-and-logs",
    "content": "turbo.json"
  }, {
    "heading": "task-running-and-logs",
    "content": "Terminal UI"
  }, {
    "heading": "task-running-and-logs",
    "content": "--ui"
  }, {
    "heading": "task-running-and-logs",
    "content": "TURBO_UI"
  }, {
    "heading": "task-running-and-logs",
    "content": "ui"
  }, {
    "heading": "task-running-and-logs",
    "content": "Run affected tasks"
  }, {
    "heading": "task-running-and-logs",
    "content": "--affected"
  }, {
    "heading": "task-running-and-logs",
    "content": "-"
  }, {
    "heading": "task-running-and-logs",
    "content": "-"
  }, {
    "heading": "task-running-and-logs",
    "content": "Disable package manager check"
  }, {
    "heading": "task-running-and-logs",
    "content": "--dangerously-disable-package-manager-check"
  }, {
    "heading": "task-running-and-logs",
    "content": "TURBO_DANGEROUSLY_DISABLE_PACKAGE_MANAGER_CHECK"
  }, {
    "heading": "task-running-and-logs",
    "content": "dangerouslyDisablePackageManagerCheck"
  }, {
    "heading": "task-running-and-logs",
    "content": "Affected base ref"
  }, {
    "heading": "task-running-and-logs",
    "content": "-"
  }, {
    "heading": "task-running-and-logs",
    "content": "TURBO_SCM_BASE"
  }, {
    "heading": "task-running-and-logs",
    "content": "-"
  }, {
    "heading": "task-running-and-logs",
    "content": "Affected head ref"
  }, {
    "heading": "task-running-and-logs",
    "content": "-"
  }, {
    "heading": "task-running-and-logs",
    "content": "TURBO_SCM_HEAD"
  }, {
    "heading": "task-running-and-logs",
    "content": "-"
  }, {
    "heading": "task-running-and-logs",
    "content": "Only run directly specified tasks"
  }, {
    "heading": "task-running-and-logs",
    "content": "--only"
  }, {
    "heading": "task-running-and-logs",
    "content": "-"
  }, {
    "heading": "task-running-and-logs",
    "content": "-"
  }, {
    "heading": "task-running-and-logs",
    "content": "Task concurrency"
  }, {
    "heading": "task-running-and-logs",
    "content": "--concurrency"
  }, {
    "heading": "task-running-and-logs",
    "content": "-"
  }, {
    "heading": "task-running-and-logs",
    "content": "-"
  }, {
    "heading": "task-running-and-logs",
    "content": "Task log order"
  }, {
    "heading": "task-running-and-logs",
    "content": "--log-order"
  }, {
    "heading": "task-running-and-logs",
    "content": "TURBO_LOG_ORDER"
  }, {
    "heading": "task-running-and-logs",
    "content": "-"
  }, {
    "heading": "task-running-and-logs",
    "content": "Current working directory"
  }, {
    "heading": "task-running-and-logs",
    "content": "--cwd"
  }, {
    "heading": "task-running-and-logs",
    "content": "-"
  }, {
    "heading": "task-running-and-logs",
    "content": "-"
  }, {
    "heading": "task-running-and-logs",
    "content": "Streamed logs prefix"
  }, {
    "heading": "task-running-and-logs",
    "content": "--log-prefix"
  }, {
    "heading": "task-running-and-logs",
    "content": "-"
  }, {
    "heading": "task-running-and-logs",
    "content": "-"
  }, {
    "heading": "task-running-and-logs",
    "content": "Task logs output level"
  }, {
    "heading": "task-running-and-logs",
    "content": "--output-logs-option"
  }, {
    "heading": "task-running-and-logs",
    "content": "-"
  }, {
    "heading": "task-running-and-logs",
    "content": "outputLogs"
  }, {
    "heading": "task-running-and-logs",
    "content": "Global inputs"
  }, {
    "heading": "task-running-and-logs",
    "content": "--global-deps"
  }, {
    "heading": "task-running-and-logs",
    "content": "-"
  }, {
    "heading": "task-running-and-logs",
    "content": "globalDependencies"
  }, {
    "heading": "task-running-and-logs",
    "content": "Terminal colors"
  }, {
    "heading": "task-running-and-logs",
    "content": "--color"
  }, {
    "heading": "task-running-and-logs",
    "content": "FORCE_COLOR"
  }, {
    "heading": "task-running-and-logs",
    "content": "-"
  }, {
    "heading": "environment-variables",
    "content": "Behavior"
  }, {
    "heading": "environment-variables",
    "content": "Flags"
  }, {
    "heading": "environment-variables",
    "content": "Environment Variables"
  }, {
    "heading": "environment-variables",
    "content": "turbo.json"
  }, {
    "heading": "environment-variables",
    "content": "Environment variable mode"
  }, {
    "heading": "environment-variables",
    "content": "--env-mode"
  }, {
    "heading": "environment-variables",
    "content": "-"
  }, {
    "heading": "environment-variables",
    "content": "envMode"
  }, {
    "heading": "environment-variables",
    "content": "Vendor environment variables"
  }, {
    "heading": "environment-variables",
    "content": "-"
  }, {
    "heading": "environment-variables",
    "content": "TURBO_CI_VENDOR_ENV_KEY"
  }, {
    "heading": "environment-variables",
    "content": "-"
  }, {
    "heading": "environment-variables",
    "content": "Framework variable exceptions"
  }, {
    "heading": "environment-variables",
    "content": "--framework-inference"
  }, {
    "heading": "environment-variables",
    "content": "-"
  }, {
    "heading": "environment-variables",
    "content": "-"
  }, {
    "heading": "debugging-outputs",
    "content": "Behavior"
  }, {
    "heading": "debugging-outputs",
    "content": "Flags"
  }, {
    "heading": "debugging-outputs",
    "content": "Environment Variables"
  }, {
    "heading": "debugging-outputs",
    "content": "turbo.json"
  }, {
    "heading": "debugging-outputs",
    "content": "Run Summaries"
  }, {
    "heading": "debugging-outputs",
    "content": "--summarize"
  }, {
    "heading": "debugging-outputs",
    "content": "TURBO_RUN_SUMMARY"
  }, {
    "heading": "debugging-outputs",
    "content": "-"
  }, {
    "heading": "debugging-outputs",
    "content": "Graph visualization"
  }, {
    "heading": "debugging-outputs",
    "content": "--graph"
  }, {
    "heading": "debugging-outputs",
    "content": "-"
  }, {
    "heading": "debugging-outputs",
    "content": "-"
  }, {
    "heading": "debugging-outputs",
    "content": "Dry run"
  }, {
    "heading": "debugging-outputs",
    "content": "--dry"
  }, {
    "heading": "debugging-outputs",
    "content": "-"
  }, {
    "heading": "debugging-outputs",
    "content": "-"
  }, {
    "heading": "authentication",
    "content": "Behavior"
  }, {
    "heading": "authentication",
    "content": "Flags"
  }, {
    "heading": "authentication",
    "content": "Environment Variables"
  }, {
    "heading": "authentication",
    "content": "turbo.json"
  }, {
    "heading": "authentication",
    "content": "Login URL"
  }, {
    "heading": "authentication",
    "content": "-"
  }, {
    "heading": "authentication",
    "content": "TURBO_LOGIN"
  }, {
    "heading": "authentication",
    "content": "remoteCache.loginUrl"
  }, {
    "heading": "authentication",
    "content": "Team name (for multi-team Remote Cache)"
  }, {
    "heading": "authentication",
    "content": "--team"
  }, {
    "heading": "authentication",
    "content": "TURBO_TEAM"
  }, {
    "heading": "authentication",
    "content": "-"
  }, {
    "heading": "authentication",
    "content": "Team ID (for multi-team Remote Cache)"
  }, {
    "heading": "authentication",
    "content": "-"
  }, {
    "heading": "authentication",
    "content": "TURBO_TEAMID"
  }, {
    "heading": "authentication",
    "content": "-"
  }, {
    "heading": "authentication",
    "content": "Authentication token"
  }, {
    "heading": "authentication",
    "content": "--token"
  }, {
    "heading": "authentication",
    "content": "TURBO_TOKEN"
  }, {
    "heading": "authentication",
    "content": "-"
  }, {
    "heading": "other",
    "content": "Behavior"
  }, {
    "heading": "other",
    "content": "Flags"
  }, {
    "heading": "other",
    "content": "Environment Variables"
  }, {
    "heading": "other",
    "content": "turbo.json"
  }, {
    "heading": "other",
    "content": "Binary path"
  }, {
    "heading": "other",
    "content": "-"
  }, {
    "heading": "other",
    "content": "TURBO_BINARY_PATH"
  }, {
    "heading": "other",
    "content": "-"
  }, {
    "heading": "other",
    "content": "Download local turbo"
  }, {
    "heading": "other",
    "content": "-"
  }, {
    "heading": "other",
    "content": "TURBO_DOWNLOAD_LOCAL_ENABLED"
  }, {
    "heading": "other",
    "content": "-"
  }, {
    "heading": "other",
    "content": "Daemon"
  }, {
    "heading": "other",
    "content": "--daemon / --no-daemon"
  }, {
    "heading": "other",
    "content": "-"
  }, {
    "heading": "other",
    "content": "daemon"
  }],
  "headings": [{
    "id": "options-table",
    "content": "Options table"
  }, {
    "id": "caching",
    "content": "Caching"
  }, {
    "id": "messages",
    "content": "Messages"
  }, {
    "id": "task-running-and-logs",
    "content": "Task running and logs"
  }, {
    "id": "environment-variables",
    "content": "Environment variables"
  }, {
    "id": "debugging-outputs",
    "content": "Debugging outputs"
  }, {
    "id": "authentication",
    "content": "Authentication"
  }, {
    "id": "other",
    "content": "Other"
  }]
};
export const toc = [{
  depth: 2,
  url: "#options-table",
  title: _jsx(_Fragment, {
    children: "Options table"
  })
}, {
  depth: 3,
  url: "#caching",
  title: _jsx(_Fragment, {
    children: "Caching"
  })
}, {
  depth: 3,
  url: "#messages",
  title: _jsx(_Fragment, {
    children: "Messages"
  })
}, {
  depth: 3,
  url: "#task-running-and-logs",
  title: _jsx(_Fragment, {
    children: "Task running and logs"
  })
}, {
  depth: 3,
  url: "#environment-variables",
  title: _jsx(_Fragment, {
    children: "Environment variables"
  })
}, {
  depth: 3,
  url: "#debugging-outputs",
  title: _jsx(_Fragment, {
    children: "Debugging outputs"
  })
}, {
  depth: 3,
  url: "#authentication",
  title: _jsx(_Fragment, {
    children: "Authentication"
  })
}, {
  depth: 3,
  url: "#other",
  title: _jsx(_Fragment, {
    children: "Other"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    li: "li",
    p: "p",
    table: "table",
    tbody: "tbody",
    td: "td",
    th: "th",
    thead: "thead",
    tr: "tr",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: ["There are three ways to manage the behavior of a ", _jsx(_components.code, {
        children: "turbo"
      }), " invocation:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsxs(_components.a, {
          href: "/docs/reference/configuration",
          children: ["Configuration in ", _jsx(_components.code, {
            children: "turbo.json"
          })]
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/docs/reference/system-environment-variables",
          children: "System Environment Variables"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/docs/reference/run",
          children: "Flags passed to the CLI invocation"
        })
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["The three strategies listed above are in order of precedence. Where a flag value is provided, for the same System Environment Variable or ", _jsx(_components.code, {
        children: "turbo.json"
      }), " configuration, the value for the flag will be used. Because of this, we recommend using:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "turbo.json"
        }), " configuration for defaults"]
      }), "\n", _jsx(_components.li, {
        children: "System Environment Variables for per-environment overrides"
      }), "\n", _jsx(_components.li, {
        children: "Flags for per-invocation overrides"
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "options-table",
      children: "Options table"
    }), "\n", _jsx(_components.h3, {
      id: "caching",
      children: "Caching"
    }), "\n", _jsx("div", {
      className: "options-cheat-sheet-table",
      children: _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: "Behavior"
            }), _jsx(_components.th, {
              children: "Flags"
            }), _jsx(_components.th, {
              children: "Environment Variables"
            }), _jsx(_components.th, {
              children: "turbo.json"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Force tasks to run"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--force",
                children: _jsx(_components.code, {
                  children: "--force"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_force",
                children: _jsx(_components.code, {
                  children: "TURBO_FORCE"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/configuration#cache",
                children: _jsx(_components.code, {
                  children: "cache"
                })
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Remote Cache timeout"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/configuration#timeout",
                children: _jsx(_components.code, {
                  children: "--remote-cache-timeout"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_remote_cache_timeout",
                children: _jsx(_components.code, {
                  children: "TURBO_REMOTE_CACHE_TIMEOUT"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/configuration#timeout",
                children: _jsx(_components.code, {
                  children: "remoteCache.timeout"
                })
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Remote Cache upload timeout"
            }), _jsx(_components.td, {
              children: "-"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_remote_cache_upload_timeout",
                children: _jsx(_components.code, {
                  children: "TURBO_REMOTE_CACHE_UPLOAD_TIMEOUT"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/configuration#uploadtimeout",
                children: _jsx(_components.code, {
                  children: "remoteCache.uploadTimeout"
                })
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Cache signature key"
            }), _jsx(_components.td, {
              children: "-"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_remote_cache_signature_key",
                children: _jsx(_components.code, {
                  children: "TURBO_REMOTE_CACHE_SIGNATURE_KEY"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/configuration#signature",
                children: _jsx(_components.code, {
                  children: "signature"
                })
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Preflight request"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--preflight",
                children: _jsx(_components.code, {
                  children: "--preflight"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_preflight",
                children: _jsx(_components.code, {
                  children: "TURBO_PREFLIGHT"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/configuration#preflight",
                children: _jsx(_components.code, {
                  children: "remoteCache.preflight"
                })
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Remote Cache base URL"
            }), _jsx(_components.td, {
              children: "-"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_api",
                children: _jsx(_components.code, {
                  children: "TURBO_API"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/configuration#remote-caching",
                children: _jsx(_components.code, {
                  children: "remoteCache.apiUrl"
                })
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Cache sources"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--cache-options",
                children: _jsx(_components.code, {
                  children: "--cache"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_cache",
                children: _jsx(_components.code, {
                  children: "TURBO_CACHE"
                })
              })
            }), _jsx(_components.td, {
              children: "-"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Local cache directory"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--cache-dir-path",
                children: _jsx(_components.code, {
                  children: "--cache-dir"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_cache_dir",
                children: _jsx(_components.code, {
                  children: "TURBO_CACHE_DIR"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/configuration#cachedir",
                children: _jsx(_components.code, {
                  children: "cacheDir"
                })
              })
            })]
          })]
        })]
      })
    }), "\n", _jsx(_components.h3, {
      id: "messages",
      children: "Messages"
    }), "\n", _jsx("div", {
      className: "options-cheat-sheet-table",
      children: _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: "Behavior"
            }), _jsx(_components.th, {
              children: "Flags"
            }), _jsx(_components.th, {
              children: "Environment Variables"
            }), _jsx(_components.th, {
              children: "turbo.json"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Disable version print"
            }), _jsx(_components.td, {
              children: "-"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_print_version_disabled",
                children: _jsx(_components.code, {
                  children: "TURBO_PRINT_VERSION_DISABLED"
                })
              })
            }), _jsx(_components.td, {
              children: "-"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Disable telemetry message"
            }), _jsx(_components.td, {
              children: "-"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_telemetry_message_disabled",
                children: _jsx(_components.code, {
                  children: "TURBO_TELEMETRY_MESSAGE_DISABLED"
                })
              })
            }), _jsx(_components.td, {
              children: "-"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsxs(_components.td, {
              children: ["Disable global ", _jsx(_components.code, {
                children: "turbo"
              }), " warning"]
            }), _jsx(_components.td, {
              children: "-"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_global_warning_disabled",
                children: _jsx(_components.code, {
                  children: "TURBO_GLOBAL_WARNING_DISABLED"
                })
              })
            }), _jsx(_components.td, {
              children: "-"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "No update notifier"
            }), _jsx(_components.td, {
              children: "-"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_no_update_notifier",
                children: _jsx(_components.code, {
                  children: "TURBO_NO_UPDATE_NOTIFIER"
                })
              })
            }), _jsx(_components.td, {
              children: "-"
            })]
          })]
        })]
      })
    }), "\n", _jsx(_components.h3, {
      id: "task-running-and-logs",
      children: "Task running and logs"
    }), "\n", _jsx("div", {
      className: "options-cheat-sheet-table",
      children: _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: "Behavior"
            }), _jsx(_components.th, {
              children: "Flags"
            }), _jsx(_components.th, {
              children: "Environment Variables"
            }), _jsx(_components.th, {
              children: "turbo.json"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Terminal UI"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--ui",
                children: _jsx(_components.code, {
                  children: "--ui"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_ui",
                children: _jsx(_components.code, {
                  children: "TURBO_UI"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/configuration#ui",
                children: _jsx(_components.code, {
                  children: "ui"
                })
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Run affected tasks"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--affected",
                children: _jsx(_components.code, {
                  children: "--affected"
                })
              })
            }), _jsx(_components.td, {
              children: "-"
            }), _jsx(_components.td, {
              children: "-"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Disable package manager check"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--dangerously-disable-package-manager-check",
                children: _jsx(_components.code, {
                  children: "--dangerously-disable-package-manager-check"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_dangerously_disable_package_manager_check",
                children: _jsx(_components.code, {
                  children: "TURBO_DANGEROUSLY_DISABLE_PACKAGE_MANAGER_CHECK"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/configuration#dangerouslydisablepackagemanagercheck",
                children: _jsx(_components.code, {
                  children: "dangerouslyDisablePackageManagerCheck"
                })
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Affected base ref"
            }), _jsx(_components.td, {
              children: "-"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_scm_base",
                children: _jsx(_components.code, {
                  children: "TURBO_SCM_BASE"
                })
              })
            }), _jsx(_components.td, {
              children: "-"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Affected head ref"
            }), _jsx(_components.td, {
              children: "-"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_scm_head",
                children: _jsx(_components.code, {
                  children: "TURBO_SCM_HEAD"
                })
              })
            }), _jsx(_components.td, {
              children: "-"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Only run directly specified tasks"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--only",
                children: _jsx(_components.code, {
                  children: "--only"
                })
              })
            }), _jsx(_components.td, {
              children: "-"
            }), _jsx(_components.td, {
              children: "-"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Task concurrency"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--concurrency-number--percentage",
                children: _jsx(_components.code, {
                  children: "--concurrency"
                })
              })
            }), _jsx(_components.td, {
              children: "-"
            }), _jsx(_components.td, {
              children: "-"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Task log order"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--log-order-option",
                children: _jsx(_components.code, {
                  children: "--log-order"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_log_order",
                children: _jsx(_components.code, {
                  children: "TURBO_LOG_ORDER"
                })
              })
            }), _jsx(_components.td, {
              children: "-"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Current working directory"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--cwd-path",
                children: _jsx(_components.code, {
                  children: "--cwd"
                })
              })
            }), _jsx(_components.td, {
              children: "-"
            }), _jsx(_components.td, {
              children: "-"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Streamed logs prefix"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--log-prefix-option",
                children: _jsx(_components.code, {
                  children: "--log-prefix"
                })
              })
            }), _jsx(_components.td, {
              children: "-"
            }), _jsx(_components.td, {
              children: "-"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Task logs output level"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--output-logs-option",
                children: _jsx(_components.code, {
                  children: "--output-logs-option"
                })
              })
            }), _jsx(_components.td, {
              children: "-"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/configuration#outputlogs",
                children: _jsx(_components.code, {
                  children: "outputLogs"
                })
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Global inputs"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--global-deps-file-glob",
                children: _jsx(_components.code, {
                  children: "--global-deps"
                })
              })
            }), _jsx(_components.td, {
              children: "-"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/configuration#globaldependencies",
                children: _jsx(_components.code, {
                  children: "globalDependencies"
                })
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Terminal colors"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference#--color",
                children: _jsx(_components.code, {
                  children: "--color"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#force_color",
                children: "FORCE_COLOR"
              })
            }), _jsx(_components.td, {
              children: "-"
            })]
          })]
        })]
      })
    }), "\n", _jsx(_components.h3, {
      id: "environment-variables",
      children: "Environment variables"
    }), "\n", _jsx("div", {
      className: "options-cheat-sheet-table",
      children: _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: "Behavior"
            }), _jsx(_components.th, {
              children: "Flags"
            }), _jsx(_components.th, {
              children: "Environment Variables"
            }), _jsx(_components.th, {
              children: "turbo.json"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Environment variable mode"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--env-mode-option",
                children: _jsx(_components.code, {
                  children: "--env-mode"
                })
              })
            }), _jsx(_components.td, {
              children: "-"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/configuration#envmode",
                children: _jsx(_components.code, {
                  children: "envMode"
                })
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Vendor environment variables"
            }), _jsx(_components.td, {
              children: "-"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_ci_vendor_env_key",
                children: _jsx(_components.code, {
                  children: "TURBO_CI_VENDOR_ENV_KEY"
                })
              })
            }), _jsx(_components.td, {
              children: "-"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Framework variable exceptions"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--framework-inference",
                children: _jsx(_components.code, {
                  children: "--framework-inference"
                })
              })
            }), _jsx(_components.td, {
              children: "-"
            }), _jsx(_components.td, {
              children: "-"
            })]
          })]
        })]
      })
    }), "\n", _jsx(_components.h3, {
      id: "debugging-outputs",
      children: "Debugging outputs"
    }), "\n", _jsx("div", {
      className: "options-cheat-sheet-table",
      children: _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: "Behavior"
            }), _jsx(_components.th, {
              children: "Flags"
            }), _jsx(_components.th, {
              children: "Environment Variables"
            }), _jsx(_components.th, {
              children: "turbo.json"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Run Summaries"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--summarize",
                children: _jsx(_components.code, {
                  children: "--summarize"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_run_summary",
                children: _jsx(_components.code, {
                  children: "TURBO_RUN_SUMMARY"
                })
              })
            }), _jsx(_components.td, {
              children: "-"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Graph visualization"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--graph-file-type",
                children: _jsx(_components.code, {
                  children: "--graph"
                })
              })
            }), _jsx(_components.td, {
              children: "-"
            }), _jsx(_components.td, {
              children: "-"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Dry run"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--dry----dry-run",
                children: _jsx(_components.code, {
                  children: "--dry"
                })
              })
            }), _jsx(_components.td, {
              children: "-"
            }), _jsx(_components.td, {
              children: "-"
            })]
          })]
        })]
      })
    }), "\n", _jsx(_components.h3, {
      id: "authentication",
      children: "Authentication"
    }), "\n", _jsx("div", {
      className: "options-cheat-sheet-table",
      children: _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: "Behavior"
            }), _jsx(_components.th, {
              children: "Flags"
            }), _jsx(_components.th, {
              children: "Environment Variables"
            }), _jsx(_components.th, {
              children: "turbo.json"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Login URL"
            }), _jsx(_components.td, {
              children: "-"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_login",
                children: _jsx(_components.code, {
                  children: "TURBO_LOGIN"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/configuration#loginurl",
                children: _jsx(_components.code, {
                  children: "remoteCache.loginUrl"
                })
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Team name (for multi-team Remote Cache)"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--team",
                children: _jsx(_components.code, {
                  children: "--team"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_team",
                children: _jsx(_components.code, {
                  children: "TURBO_TEAM"
                })
              })
            }), _jsx(_components.td, {
              children: "-"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Team ID (for multi-team Remote Cache)"
            }), _jsx(_components.td, {
              children: "-"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_teamid",
                children: _jsx(_components.code, {
                  children: "TURBO_TEAMID"
                })
              })
            }), _jsx(_components.td, {
              children: "-"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Authentication token"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--token",
                children: _jsx(_components.code, {
                  children: "--token"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_token",
                children: _jsx(_components.code, {
                  children: "TURBO_TOKEN"
                })
              })
            }), _jsx(_components.td, {
              children: "-"
            })]
          })]
        })]
      })
    }), "\n", _jsx(_components.h3, {
      id: "other",
      children: "Other"
    }), "\n", _jsx("div", {
      className: "options-cheat-sheet-table",
      children: _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: "Behavior"
            }), _jsx(_components.th, {
              children: "Flags"
            }), _jsx(_components.th, {
              children: "Environment Variables"
            }), _jsx(_components.th, {
              children: "turbo.json"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Binary path"
            }), _jsx(_components.td, {
              children: "-"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_binary_path",
                children: _jsx(_components.code, {
                  children: "TURBO_BINARY_PATH"
                })
              })
            }), _jsx(_components.td, {
              children: "-"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsxs(_components.td, {
              children: ["Download local ", _jsx(_components.code, {
                children: "turbo"
              })]
            }), _jsx(_components.td, {
              children: "-"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_download_local_enabled",
                children: _jsx(_components.code, {
                  children: "TURBO_DOWNLOAD_LOCAL_ENABLED"
                })
              })
            }), _jsx(_components.td, {
              children: "-"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Daemon"
            }), _jsx(_components.td, {
              children: _jsxs(_components.a, {
                href: "/docs/reference/run#--daemon-and---no-daemon",
                children: [_jsx(_components.code, {
                  children: "--daemon"
                }), " / ", _jsx(_components.code, {
                  children: "--no-daemon"
                })]
              })
            }), _jsx(_components.td, {
              children: "-"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/configuration#daemon",
                children: _jsx(_components.code, {
                  children: "daemon"
                })
              })
            })]
          })]
        })]
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
